import type { ReactNode } from "react";

export function PageHeader({
	eyebrow,
	title,
	description,
	actions,
}: {
	eyebrow?: string;
	title: string;
	description?: ReactNode;
	actions?: ReactNode;
}) {
	return (
		<header className="mb-6 flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between md:gap-6">
			<div className="min-w-0">
				{!!eyebrow && <p className="mb-1.5 type-eyebrow text-muted-foreground">{eyebrow}</p>}

				<h1 className="type-page-title text-foreground">{title}</h1>

				{!!description && (
					<p className="mt-2 max-w-2xl text-sm text-muted-foreground">{description}</p>
				)}
			</div>

			{!!actions && (
				<div className="flex w-full shrink-0 flex-wrap items-center gap-2 md:w-auto md:max-w-1/2">
					{actions}
				</div>
			)}
		</header>
	);
}
